import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserRegisterComponent } from '@features/user/components/user-register/user-register.component';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';

@Component({
    selector: 'app-user-register-detail',
    templateUrl: './user-register-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [UserRegisterComponent, CtaButtonComponent],
})
export class UserRegisterDetailComponent {}
